import {
  buildMenuTree,
  flattenCustomImage,
  stripHTML,
  toRelativeUrl,
} from '../../utils/helperTransforms.wp';

// Recursively normalise a menu item (and its children) so every level exposes a
// flat `featuredImage` and `excerpt` — the mobile nav shows excerpts at depth.
//
// Children are mapped first so an item without its own featured image can fall
// back to the first child that has one (the desktop Level 2 panel always wants
// something in `.NavLevel2Menu-media`). The children are already resolved at
// that point, so the fallback cascades up from any depth.
function mapMenuItem(item) {
  const children = Array.isArray(item.children)
    ? item.children.map(mapMenuItem)
    : [];

  const ownImage =
    flattenCustomImage(item.connectedNode?.node?.featuredImage) || null;
  const inheritedImage =
    children.find((child) => child.featuredImage)?.featuredImage || null;

  return {
    ...item,
    featuredImage: ownImage || inheritedImage,
    excerpt: stripHTML(item.connectedNode?.node?.excerpt) || null,
    children,
  };
}

// Transforms the shared navigation data consumed by both NavigationDesktop and
// NavigationMobile. `menuItems` is the single source of truth for both navs;
// `search` is desktop-only and `contactLinks`/`toggleMenuLabel` are mobile-only.
export function transformNavigationMain(data) {
  const nodes = data?.menu?.menuItems?.nodes || [];
  const mainOptions = data?.globalOptionsDefault?.globalNavigationmain || {};

  const rawApplyLink = mainOptions?.global_navigationmain_applylink;

  return {
    menuItems: buildMenuTree(nodes).map(mapMenuItem),
    site: {
      link: '/',
      title: data?.generalSettings?.title || 'Site title',
    },
    search: {
      title: mainOptions?.global_navigationmain_search?.title || 'Search',
      subtitle:
        mainOptions?.global_navigationmain_search?.subtitle ||
        'What are you looking for?',
    },
    applyLink: rawApplyLink?.url
      ? {
          url: toRelativeUrl(rawApplyLink.url),
          title: rawApplyLink.title || 'Inquire',
          target: rawApplyLink.target || null,
        }
      : null,
    contactLinks: Array.isArray(mainOptions?.global_navigationmain_contactlinks)
      ? mainOptions.global_navigationmain_contactlinks.map((item) => ({
          target: item?.link?.target || false,
          title: item?.link?.title || false,
          url: toRelativeUrl(item?.link?.url || false),
        }))
      : [],
    siteTitle: data?.generalSettings?.title || '',
  };
}
